import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICoreState } from './state';

export const selectCoreState = createFeatureSelector<ICoreState>('core');

export const selectUser = createSelector(selectCoreState, (state) => state.user);
export const selectToken = createSelector(selectCoreState, (state) => state.token);
export const selectIsLogged = createSelector(selectUser, (user) => !!user);
export const selectSidenavOpened = createSelector(
  selectCoreState,
  (state) => state.sidenavOpened
);
export const selectAuthStep = createSelector(selectCoreState, (state) => state.authStep);
export const selectAuthError = createSelector(selectCoreState, (state) => state.authError);
export const selectPendingUsername = createSelector(
  selectCoreState,
  (state) => state.pendingUsername
);
export const selectPendingUserCode = createSelector(
  selectCoreState,
  (state) => state.pendingUserCode
);
export const selectPendingEncryptedUser = createSelector(
  selectCoreState,
  (state) => state.pendingEncryptedUser
);
export const selectPendingIntermediateToken = createSelector(
  selectCoreState,
  (state) => state.pendingIntermediateToken
);
